import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=06f02f5a&scoped=true"
import script from "./PersonalProfile.vue?vue&type=script&lang=js"
export * from "./PersonalProfile.vue?vue&type=script&lang=js"
import style0 from "./PersonalProfile.vue?vue&type=style&index=0&id=06f02f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f02f5a",
  null
  
)

export default component.exports